import classes from './Feedback.module.css'

const lang = localStorage.getItem("LANG");

const config = {
    // Syncfusion Rich Text Editor configuration for feedback and evaluation
    enableAutoUrl: true,
    saveInterval: 500,
    locale: lang === 'he' || lang === 'ar' ? 'he' : 'en',
    enableRtl: lang === 'he' || lang === 'ar',
    pasteCleanupSettings: { 
        keepFormat: false, 
        removeLineBreaks: true, 
        plainText: true 
    },
    insertImageSettings: {
        saveFormat: "Blob"
    },
    fontFamily: {
        default: 'Heebo',
        width: '50px',
        items: [
            { text: 'Heebo', value: 'Heebo' },
            { text: 'Arial', value: 'arial,helvetica,sans-serif' },
            { text: 'Times New Roman', value: 'times new roman,times' },
            { text: 'Georgia', value: 'georgia,palatino' },
            { text: 'Verdana', value: 'verdana,geneva' }
        ]
    },
    fontSize: {
        default: '14px',
        width: '40px',
        items: [
            { text: '8px', value: '8px' },
            { text: '10px', value: '10px' },
            { text: '12px', value: '12px' },
            { text: '14px', value: '14px' },
            { text: '16px', value: '16px' },
            { text: '18px', value: '18px' },
            { text: '20px', value: '20px' },
            { text: '24px', value: '24px' }
        ]
    },
    toolbarSettings: {
        items: [
            "FontSize",
            "FontName", 
            "Bold",
            "Italic",
            "Underline",
            "FontColor",
            "BackgroundColor",
            "Alignments",
            "OrderedList",
            "UnorderedList",
            "CreateLink",
            "RemoveLink",
            "Undo",
            "Redo",
            "ClearFormat"
        ]
    },
    quickToolbarSettings: {
        table: ['TableHeader', 'TableRows', 'TableColumns', 'Alignments', 'Delete', 'TableCellVerticalAlign', 'Styles']
    }
}

export default config
